export default {
  'account-settings.menuMap.basic': '基本设置',
  'account-settings.menuMap.security': '安全设置',
  'account-settings.menuMap.binding': '账号绑定',
  'account-settings.menuMap.notification': '新消息通知',
  'account-settings.basic.avatar': '头像',
  'account-settings.basic.change-avatar': '更换头像',
  'account-settings.basic.email': '邮箱',
  'account-settings.basic.email-message': '请输入您的邮箱!',
  'account-settings.basic.nickname': '昵称',
  'account-settings.basic.nickname-message': '请输入您的昵称!',
  'account-settings.basic.profile': '个人简介',
  'account-settings.basic.profile-message': '请输入个人简介!',
  'account-settings.basic.profile-placeholder': '个人简介',
  'account-settings.basic.country': '国家/地区',
  'account-settings.basic.country-message': '请输入您的国家或地区!',
  'account-settings.basic.geographic': '所在省市',
  'account-settings.basic.geographic-message': '请输入您的所在省市!',
  'account-settings.basic.address': '街道地址',
  'account-settings.basic.address-message': '请输入您的街道地址!',
  'account-settings.basic.phone': '联系电话',
  'account-settings.basic.phone-message': '请输入您的联系电话!',
  'account-settings.basic.update': '更新基本信息',
  'account-settings.basic.update.success': '更新基本信息成功',
  'account-settings.security.strong': '强',
  'account-settings.security.medium': '中',
  'account-settings.security.weak': '弱',
  'account-settings.security.password': '账户密码',
  'account-settings.security.password-description': '当前密码强度：',
  'account-settings.security.phone': '密保手机',
  'account-settings.security.phone-description': '已绑定手机：',
  'account-settings.security.question': '密保问题',
  'account-settings.security.question-description': '未设置密保问题，密保问题可有效保护账户安全',
  'account-settings.security.email': '备用邮箱',
  'account-settings.security.email-description': '已绑定邮箱：',
  'account-settings.security.mfa': 'MFA 设备',
  'account-settings.security.mfa-description': '未绑定 MFA 设备，绑定后，可以进行二次确认',
  'account-settings.security.modify': '修改',
  'account-settings.security.set': '设置',
  'account-settings.security.bind': '绑定',
  'account-settings.binding.taobao': '绑定淘宝',
  'account-settings.binding.taobao-description': '当前未绑定淘宝账号',
  'account-settings.binding.alipay': '绑定支付宝',
  'account-settings.binding.alipay-description': '当前未绑定支付宝账号',
  'account-settings.binding.dingding': '绑定钉钉',
  'account-settings.binding.dingding-description': '当前未绑定钉钉账号',
  'account-settings.binding.bind': '绑定',
  'account-settings.notification.password': '账户密码',
  'account-settings.notification.password-description': '其他用户的消息将以站内信的形式通知',
  'account-settings.notification.messages': '系统消息',
  'account-settings.notification.messages-description': '系统消息将以站内信的形式通知',
  'account-settings.notification.todo': '待办任务',
  'account-settings.notification.todo-description': '待办任务将以站内信的形式通知',
  'account-settings.settings.open': '开',
  'account-settings.settings.close': '关',
};
